import {Component, OnInit, Input, Inject} from 'ng-metadata/core';
import {STATE_NAMES} from '../../../primoExplore/primoExploreStates.module';
import {BrowseSearchBarService} from "../browseSearchBar/browseSearchBar.service";
import {BrowseResultService} from "./browseResult.service";
import {BrowseSearchService} from "../browseSearch.service";
import {getVid} from '../../../appConfig/appConfigForward';
import {beacon, PrimolyticsService} from "../../../analytics/primolytics.service";
import {ConfigurationUtil} from "../../../nddUtils/configurationUtil.service";
import {ChangeLangService} from "../../../infra/lang/changeLang.service";


@Component({
    selector: 'prm-browse-result',
    templateUrl: 'components/search/browse/browseResult/browse-result.html',
})

export class PrmBrowseResult implements OnInit{
    @Input() public browseResult: Object;
    constructor(private browseResultService: BrowseResultService,
                private browseSearchBarService: BrowseSearchBarService,
                private browseSearchService: BrowseSearchService,
                private primolyticsService: PrimolyticsService,
                @Inject('$state') private $state: ng.ui.IStateService,
                @Inject('browseIcons') private browseIcons:Object[],
                @Inject('$element') private $element,
                private configurationUtil: ConfigurationUtil,
                private changeLangService: ChangeLangService,
                @Inject('$translate')  private $translate:ng.translate.ITranslateService) {
    }

    ngOnInit() {
        this.browseResultService.browseResult  = this.browseResult;
        // this.item = Json.parse(this.)
        if (!this.haveLink){
            let linkElement= this.$element[0].querySelector('a');
            linkElement.style.cursor='default';
        }
    }

    get recString(){
        let str = "";
        for(var i in this.browseResult.displayValue){
            str += i;
        }
        str += "      " +"number of records = " +this.browseResult.docIds.length;
        return str;
    }



    get prefTitle(){
        let allTitle:string[] = []
        for(var i in this.browseResult.displayValue){
            allTitle.push(i);
        }
        return allTitle;
    }

    get numberOfCrossRef(){
        console.log(this.browseResult.displayValue.length)
        return Object.keys(this.browseResult.displayValue).length>1?true:false;
    }

    get title(): string{
        let str = "";
        for(var i in this.browseResult.displayValue){
            str += i;
        }
        return str;
    }

    get numberOfDocs(): number{
        if(this.configurationUtil.isSuprima()){
            return parseInt(this.browseResult.numberOfResults);
        }
        else{
            return this.browseResult.docIds.length;
        }
    }

    public get callNumberDoc(){
        if(this.browseResult['displayValue'].length >1){
            console.log("bllue")
        }
        return this.browseResult['displayValue'][this.title];
    }

    private getHeaderResultsStateParams(){
        let que;

        if(this.configurationUtil.isSuprima()){
            que = 'Browse: '+ this.browseResult['displayValue'][this.title];
        }
        else{
             que = this.havePref? this.callNumberDoc:this.browseResult['indexTextValue'];
        }
        return this.headerQuryResultParam(que);
    }

    private headerQuryResultParam(que: any) {
        let browseParams;
        let docCount:String =this.numberOfDocs;
        if(this.configurationUtil.isSuprima()){
            browseParams = JSON.stringify(this.browseResult.searchParams);
            this.browseResultService.query = que;
        }
        else {
            this.browseResultService.query = 'browse_' + this.browseSearchBarService.selectedScope['SourceCode1'] + ',exact,' +
                que;
        }
            return {
                vid: getVid(),
                query: this.browseResultService.query,
                sortby: this.browseSearchBarService.selectedScope['SourceCode2'],
                browseQuery: this.browseSearchBarService.searchBarInput,
                browseScope: this.browseSearchService.searchedScope,
                browseFirstTerm: this.$state.params['browseFirstTerm'],//TODO: change from hardcoded
                mode: 'browse',
                browseParams: browseParams,
                innerPnxIndex: this.$state.params['innerPnxIndex'],
                numOfUsedTerms: this.browseSearchService.numOfUsedTerm,
                fn: this.$state.params['fn'],
                docCount: docCount, 
                lang: this.$translate.use()
            }
        }

    public get havePref(){
        if(this.browseResult['nonPreferred']!= undefined) {
            return true;
        }
        return false;
    }
    public get preferred(){
        return this.browseResult['nonPreferred'];
    }

    public get haveType(){
        if(this.browseResult['type'] != undefined && !this.browseResult['type'].length == 0){
            return true;
        }
        return false;
    }
    public get type(){
        return this.browseResult['type'];
    }

    private getFullDisplayStateParams(){
        let fullDisplayStateParams = {
                vid: getVid(),
                docid:this.callNumberDoc,
                browseQuery: this.browseSearchBarService.searchBarInput,
                browseScope: this.browseSearchService.searchedScope,
                browseFirstTerm:this.$state.params['browseFirstTerm'],
                mode: 'browse',
                innerPnxIndex: this.$state.params['innerPnxIndex'],
                numOfUsedTerms: this.$state.params['numOfUsedTerms'],
                fn: this.$state.params['fn']
            };
        if(this.configurationUtil.isSuprima()){
            fullDisplayStateParams.context = 'L';
        }
        return fullDisplayStateParams;
    }
   // @beacon({'p':'search', 'op': 'browseRelated'})
    public reportUse():void{
        return;
    }

    public resultLinkPref(title:string){
        let que = this.browseResult['displayValue'][title]
        return this.$state.href(STATE_NAMES.SEARCH, this.headerQuryResultParam(que));
    }

    get haveLink(){
        return this.havePref? false:true;

    }

    get resultLink(){
        if(this.havePref){
            return undefined;
        }
        if(this.isCallNumber()){
            return this.$state.href(STATE_NAMES.FULL_DISPLAY, this.getFullDisplayStateParams(),{lossy:false});
        }
        else {
            return this.$state.href(STATE_NAMES.SEARCH, this.getHeaderResultsStateParams());
        }
    }

    public isCallNumber(){
        if(this.browseSearchService.searchedScope.startsWith('call')){
            return true;
        }
        return false;

    }

    public isSubjectOrAuthor(){
        if(this.browseSearchService.searchedScope.startsWith('subject') || this.browseSearchService.searchedScope.startsWith('author')){
            return true;
        }
        return false;

    }

    get author(){
        return this.browseResult['author'];
    }
    get date(){
        return this.browseResult['date'];
    }
    get callNumber(){
        return this.browseResult['callNumber'];
    }

    get exactNumber(): string {
        if(this.configurationUtil.isSuprima()){
            return (this.browseResult.numberOfResults && this.browseResult.numberOfResults.indexOf('+') !== -1) ? '+': '';
        }
        else{
            return '';
        }
    }

    private switchToLtrString() {
        return this.changeLangService.direction == 'rtl';
    }

    private isOneOrMoreRecords() {
        if (this.numberOfDocs  <= 1) {
            return '1 ' + this.$translate.instant('nui.browse.single_rec');
        }
        else {
            return this.numberOfDocs +' '+ this.exactNumber +' '+ this.$translate.instant('nui.browse.multiple_rec');
        }
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/browse/browseResult/browseResult.directive.ts